<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
		$model.RegistrationSegmentId = null;
	}

	const handleSubmit = (e) => {
		buttons.blockNext();

		e.preventDefault();
		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey3, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/gverify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						await registerFormStart();

						buttons.next();
						buttons.unblock();
						return true;
					}

					grecaptcha.render(document.getElementById("g-recaptcha"), {
						sitekey: projectSettings.gSiteKey2,
						callback: reCaptchaV2
					});
				}

				return false;
			});
		});
	};

	const reCaptchaV2 = async (token) => {
		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json"
			},
			body: JSON.stringify({ token: token })
		};

		let url = "/api/gverifyv2";
		let response = await fetch(`${url}`, options);
		let data = await response.json();

		if (data.status) {
			await registerFormStart();

			buttons.next();
			buttons.unblock();
		}
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">Register for the {@html projectSettings.classActionName}</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					To register for the {@html projectSettings.classActionName} on a confidential, no-cost, and obligation-free basis, please click on the button below and fill out the form.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation-box-shadow">
			<FormRow style="margin-top:0px;">
				<FormColumn>
					<p class="mb-3">
						Do you agree to provide us with personal information which will be kept confidential under the
						Shine Lawyers
						<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
							>Privacy Policy</a
						>?
					</p>
					<Checkbox
						required="true"
						{disabled}
						bind:checked={$model.privacyPolicyConfirmed}
						label="I agree to the privacy policy"
						id="privacy"></Checkbox>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center" cols="12">
				<NavigationButtons
					showPrevious={false}
					bind:buttons
					nextPageLabel="REGISTER FOR THE CLASS ACTION"
					disableNext={!$model.privacyPolicyConfirmed}></NavigationButtons>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<FormRow class="justify-content-md-center confirmation-hide">
					<FormColumn>
						<p>
							If you require support completing your registration, please contact Shine Lawyers on
							<ClassActionPhoneNumber></ClassActionPhoneNumber> or email
							<ClassActionEmailAddress></ClassActionEmailAddress>.
						</p>
					</FormColumn>
				</FormRow>
				<p>
					You are eligible to join the {@html projectSettings.classActionName} if between 
					<strong>30 June 2019 and April 2024</strong>
				</p>
				<ul>
					<li>You were a member of at least one of the following superannuation funds:</li>
					<ul>
						<li>AMP Super Fund</li>
						<li>Super Directions Fund</li>
						<li>Superannuation Savings Trust</li>
						<li>AMP Retirement Trust</li>
						<li>National Mutual Retirement Fund</li>
						<li>Wealth Personal Superannuation and Pension Fund</li>
					</ul>
					<li class="noBullet">
						AND
					</li>
					<li>
						You had at least one of the following superannuation products:  
						<ul>
							<li>Accelerator Personal Superannuation Plan </li>
							<li>AMP Flexible Income Plan </li>
							<li>AMP Flexible Super </li>
							<li>AMP Flexible Super - Super, CustomSuper&reg; </li>
							<li>AMP Flexible Super&reg; - Retirement </li>
							<li>AMP MultiFund Flexible Income Plan </li>
							<li>AMP MultiFund Superannuation Bond </li>
							<li>AMP Retirement Savings Account </li>
							<li>AMP Retirement Trust </li>
							<li>AMP Super Rollover Plan - Personal Superannuation Bond </li>
							<li>AMPAK Personal Superannuation Plan </li>
							<li>Conventional Superannuation </li>
							<li>CustomSuper </li>
							<li>CustomSuper&reg; </li>
							<li>Endowment </li>
							<li>Flexible Income Plan / Flexible Pension Plan / Flexipol Personal Superannuation </li>
							<li>Flexible Lifetime - Allocated Pension </li>
							<li>Flexible Lifetime - Protection (Superannuation) </li>
							<li>Flexible Lifetime - Term Pension </li>
							<li>Flexible Lifetime&reg; - Allocated Pension, Flexible Lifetime -Super </li>
							<li>Flexible Lifetime&reg; - Super </li>
							<li>Generations&reg; Personal Super and Personal Pension </li>
							<li>Goldline Personal Superannuation Plan </li>
							<li>Guaranteed Super Pension </li>
							<li>Income Insurance Superannuation Plan / Life Protection Superannuation Plan / Life Insurance Superannuation Plan </li>
							<li>Investment Account Superannuation Bond </li>
							<li>Investment Linked Personal Superannuation Bond </li>
							<li>Investment Linked Personal Superannuation Plan </li>
							<li>Investment Linked Superannuation Plan </li>
							<li>ipac iAccess&reg; Personal Super and Allocated Pension </li>
							<li>Lifestyle Protection Plan / Superannuation Annual Renewable Term / Superannuation Life Protection Plan </li>
							<li>MyNorth&reg; Super and Pension </li>
							<li>North&reg; Super and Pension </li>
							<li>Personal Superannuation Bond / Provider Personal Retirement Plan / Provider Top Up Retirement Plan / Retirement Bond / Retirement Security Plan </li>
							<li>Personal Superannuation Plan </li>
							<li>Portfolio Plan </li>
							<li>Retirement Directions Allocated Pension Plan </li>
							<li>SignatureSuper </li>
							<li>SignatureSuper Allocated Pension </li>
							<li>SignatureSuper Select </li>
							<li>SignatureSuper&reg; </li>
							<li>Simple Super / Simple Super Rollover Plan </li>
							<li>Summit&reg; Personal Super and Personal Pension </li>
							<li>Super Directions for Business / Super Directions for Business Rollover Section / Super Directions Personal Super Plan </li>
							<li>SuperLeader&reg; </li>
							<li>Tailored Super / Tailored Super Rollover Plan </li>
							<li>Term Life Insurance Superannuation </li>
							<li>Whole of Life </li>
							<li>Yearly Renewable Term. </li>
						</ul>
					</li>
					<li class="noBullet">
						AND
					</li>
					<li>
						You paid fees from your superannuation account for Death Insurance, Death & TPD Insurance and / or Income Protection Insurance (also known as Salary Continuance Insurance). 
					</li>
				</ul>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn cols="12">
				<div class="recaptcha">
					<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
				</div>
			</FormColumn>
		</FormRow>

	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}

	.unbold {
		font-weight: normal;
	}

	ul {
		margin-left: 20px;
	}

	li {
		padding-left: 20px;
	}
	.noBullet {
		list-style-type: none;
	}
</style>
